'use client';
import React, { useState } from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import Link from 'next/link';

export default function LoginPage() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => setLoading(false), 1500);
  };

  return (
    <div className="min-h-screen flex flex-col font-tajawal" dir="rtl">
      <Navbar />
      <main className="flex-1 bg-background flex items-center justify-center py-12 px-4">
        <div className="w-full max-w-md">
          {/* Logo */}
          <div className="text-center mb-8">
            <img
              src="https://media.base44.com/images/public/69ed0fe31d3c9ede3b821281/406079c5f_Emblem_of_Yemen_2svg.png"
              alt="شعار اليمن"
              className="w-16 h-16 object-contain mx-auto mb-3" />

            <h1 className="text-2xl font-bold text-primary">تسجيل الدخول</h1>
            <p className="text-sm text-muted-foreground mt-1">منصة تصريح — وزارة الخارجية اليمنية</p>
          </div>

          <div className="bg-white rounded-2xl border border-border shadow-gov-lg p-8">
            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold text-foreground mb-1.5">
                  البريد الإلكتروني
                </label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="input-gov"
                  placeholder="example@email.com"
                  dir="ltr" />

              </div>
              <div>
                <div className="flex items-center justify-between mb-1.5">
                  <label className="text-sm font-semibold text-foreground">كلمة المرور</label>
                  <a href="#" className="text-xs text-accent hover:underline">نسيت كلمة المرور؟</a>
                </div>
                <input
                  type="password"
                  required
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="input-gov"
                  placeholder="••••••••" />

              </div>
              <button
                type="submit"
                disabled={loading}
                className="gov-btn-primary w-full justify-center disabled:opacity-50">

                {loading ?
                <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                  </svg> :
                null}
                تسجيل الدخول
              </button>
            </form>

            <div className="mt-6 pt-6 border-t border-border text-center">
              <p className="text-sm text-muted-foreground">
                ليس لديك حساب؟{' '}
                <Link href="/signup" className="text-accent font-semibold hover:underline">
                  سجّل الآن
                </Link>
              </p>
            </div>
          </div>

          {/* Security Note */}
          <div className="mt-4 flex items-center justify-center gap-2 text-xs text-muted-foreground">
            <svg className="w-3.5 h-3.5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
            اتصال آمن ومشفر
          </div>
        </div>
      </main>
      <Footer />
    </div>);

}